module.exports = __webpack_public_path__ + "static/media/img1-1.a760319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/frijol/soilcheck/mo/img1-1.png
// module id = 1622
// module chunks = 3